<div>
  <p>
    Special thanks to Prof. Dan Zedek, Emily Boardman Ndulue, and Prof. Rahul Bhargava for their valuable feedback and generosity of offering help!<br><a href="mailto: schumacher.y@northeastern.edu">Email Yuriko</a> | <a href="#main">Go back to top</a>
  </p>
</div>

<style>
  div {
    max-width: 90%;
    margin: 0 auto;
    font-family: 'Fira Sans Condensed', sans-serif;
    font-size: 0.8em;
    text-align: center;
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
  }
</style>